import App from "./app/app";

new App(document.querySelector(".webgl"));
